var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPatreon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 54,
    height: 32,
    viewBox: "0 0 54 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#31geoz9i2a)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M15.929-.464v32.913h-6.03V-.464h6.03zm15.835 0c6.813 0 12.337 5.523 12.337 12.337S38.577 24.21 31.764 24.21c-6.814 0-12.338-5.523-12.338-12.337S24.95-.464 31.764-.464z",
    fill: "#FF424D"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "31geoz9i2a"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    transform: "translate(0 -.008)",
    d: "M0 0h54v32H0z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPatreon);
export default __webpack_public_path__ + "static/media/patreon.dd3d0e95d428fffcee268dd65f8d399b.svg";
export { ForwardRef as ReactComponent };